import { api } from './api';

// GET all marketing items (carousel items)
export const getMarketingItems = () => api.get('/admin/marketing-items');

// GET one full marketing item details
export const getMarketingItemDetails = (id: number) => api.get(`/admin/marketing-item/${id}`);

// UPDATE marketing item (editable fields)
export const updateMarketingItem = (id: number, data: any) => api.patch(`/admin/marketing-item/${id}`, data);

// DELETE marketing item
export const deleteMarketingItem = (id: number) => api.delete(`/admin/marketing-item/${id}`);

// CREATE a new marketing item
export const createMarketingItem = (data: any) => api.post('/admin/marketing-item', data);

// UPLOAD image
// Generic upload for creation (no ID required)
export const uploadNewMarketingImage = (file: File, meta?: string) => {
    const formData = new FormData();
    formData.append('image', file);
    if (meta) formData.append('meta', meta);
    return api.post('/admin/marketing-item/upload-image', formData);
};

// Upload for existing item (needs ID)
export const uploadMarketingImage = (id: number, file: File, meta?: string) => {
    const formData = new FormData();
    formData.append('image', file);
    if (meta) formData.append('meta', meta);
    return api.post(`/admin/marketing-item/${id}/upload-image`, formData);
};
